import React from "react";

/**
 * Dental Leads Lab — custom brand logo (SVG).
 * Mark: a tooth glyph with a rising "growth" arrow (leads going up),
 * using the site palette (blue #2563EB -> indigo, amber #F59E0B accent).
 *
 * Props:
 *  - showWordmark (bool): render the "Dental Leads Lab" wordmark next to the mark
 *  - className: sizing via height utility (e.g. "h-10"); mark + text scale with it
 *  - variant: "light" (default, for dark bg) | "mono-amber"
 */
export function LogoMark({ className = "h-10 w-auto" }) {
  return (
    <svg
      viewBox="0 0 48 48"
      className={className}
      role="img"
      aria-label="Dental Leads Lab mark"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="dll-badge" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#3B82F6" />
          <stop offset="100%" stopColor="#1D4ED8" />
        </linearGradient>
        <linearGradient id="dll-tooth" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FFFFFF" />
          <stop offset="100%" stopColor="#DCE7FF" />
        </linearGradient>
      </defs>

      {/* Badge */}
      <rect x="1.5" y="1.5" width="45" height="45" rx="13" fill="url(#dll-badge)" />
      <rect
        x="1.5"
        y="1.5"
        width="45"
        height="45"
        rx="13"
        fill="none"
        stroke="rgba(255,255,255,0.25)"
        strokeWidth="1"
      />

      {/* Tooth */}
      <path
        d="M24 10.5c-5.6 0-9.6 2.9-9.6 9.2 0 5 2 8.9 3.2 12.6 .8 2.4 3.4 2.4 4.1 .2l1.3-6.4c.4-2 2.9-2 3.3 0l1.3 6.4c.7 2.2 3.3 2.2 4.1-.2 1.2-3.7 3.2-7.6 3.2-12.6 0-6.3-4-9.2-9.2-9.2Z"
        fill="url(#dll-tooth)"
      />

      {/* Rising growth arrow (amber) */}
      <path
        d="M14 33.5 L22 27 L27.5 30.5 L35 22.5"
        fill="none"
        stroke="#F59E0B"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.5 22.2 L35.5 21.6 L35.2 26.6 Z"
        fill="#F59E0B"
      />
    </svg>
  );
}

export default function Logo({ showWordmark = true, className = "h-10" }) {
  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <LogoMark className="h-full w-auto" />
      {showWordmark && (
        <span className="leading-none">
          <span className="block font-display font-semibold tracking-tight text-white text-[1.15em]">
            Dental Leads Lab
          </span>
          <span className="block mt-1 font-mono-accent uppercase tracking-[0.28em] text-blue-400/80 text-[0.42em]">
            Growth · Systems · Results
          </span>
        </span>
      )}
    </span>
  );
}
